import React from "react";
import { SITE } from "../i18n/translations";

// React 19 automatically hoists <title>, <meta> and <link> tags to <head>.
export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  keywords = [],
  jsonLd = null,
  noindex = false,
}) {
  const url = `${SITE.domain}${path}`;
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name}`;
  const ogImage = image || "https://images.unsplash.com/photo-1546182208-1e70985e2bf3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(", ")} />}
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="en" href={url} />
      <link rel="alternate" hrefLang="bn" href={`${url}?lang=bn`} />
      <link rel="alternate" hrefLang="hi" href={`${url}?lang=hi`} />
      <link rel="alternate" hrefLang="x-default" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}
